export const Other_Service = [
  {
    _id: `0`,
    type: `TDS RETURN`,
    label: `TDS RETURN - FORM 24Q`,
    price: `1499`,
    about: `Filing of quarterly TDS return for payments of salary to employees`,
    service: [
      {
        label: `Filing of TDS return - Form 24Q`,
      },
      {
        label: `Issue of Form 16`,
      },
    ],
    who_should_buy: [
      {
        label: `Business who required to deduct TDS on salary payment made to employees`,
      },
    ],
    doc_required: [
      {
        label: `Details of salary payments along with TDS deduction details. Fill in all the required details in the template for Form 24Q. Template can be downloaded from 'Resource' page`,
      },
      {
        label: `Copy of challahs used for tax payments`,
      },
      {
        label: `Acknowledgement copy of last quarterly return filed`,
      },
    ],
  },
  {
    _id: `1`,
    type: `TDS RETURN`,
    label: `TDS RETURN - FORM 26Q`,
    price: `1499`,
    about: `TDS return filing for other payments - Form 26Q`,
    service: [
      {
        label: `Form 26 Q upto 50 deductees`,
      },
      {
        label: `Bulk PAN verification`,
      },
      {
        label: `Challan Verification`,
      },
      {
        label: `FVU generation and submission`,
      },
      {
        label: `Issue of form 16A`,
      },
    ],
    who_should_buy: [
      {
        label: `Any Individual, partnership firm or corporate who is required to deduct TDS on payments other than salary under section 194C, 194J, 194I etc.`,
      },
    ],
    doc_required: [
      {
        label: `Details of deductor`,
      },
      {
        label: `Details of vendor whose TDS has been deducted`,
      },
      {
        label: `Challan details`,
      },
      {
        label: `Details of deductions`,
      },
    ],
  },
  {
    _id: `2`,
    type: `TDS RETURN`,
    label: `TDS RETURN - 26QB - PROPERTY`,
    price: `1599`,
    about: `Filing of TDS return Form 26QB - TDS on sale of property`,
    service: [
      {
        label: `Filing of TDS return for sale of property`,
      },
    ],
    who_should_buy: [
      {
        label: `Anyone who has purchased property worth over Rs 50 lakhs`,
      },
    ],
    doc_required: [
      {
        label: `Details of seller of the property`,
      },
      {
        label: `Transaction details`,
      },
      {
        label: `PAN of the purchaser of the property`,
      },
    ],
  },
  {
    _id: `3`,
    type: `TDS RETURN`,
    label: `TDS RETURN - FORM 27Q`,
    price: `1499`,
    about: `Filing of quarterly TDS return for payments other than salary to Non residents on India under section 195`,
    service: [
      {
        label: `Filing of TDS return - Form 27Q`,
      },
      {
        label: `Issue of Form 16`,
      },
    ],
    who_should_buy: [
      {
        label: `Any business which is required to make any payment to Non resident on which it is liable to deduct tax at source`,
      },
    ],
    doc_required: [
      {
        label: `Details of payments made to Non residents along with TDS deduction details. Fill the required details in the template`,
      },
      {
        label: `Copy of challans used for tax payments`,
      },
      {
        label: `Acknowledgement copy of last quarterly return filed`,
      },
    ],
  },
  {
    _id: `4`,
    type: `TDS RETURN`,
    label: `TDS RETURN - FORM 27Q`,
    price: `1499`,
    about: `Filing of TCS [Tax collected at source] return required to filed u/s 206C of the Income Tax Act, 1961`,
    service: [
      {
        label: `Filing of TCS Return - Form 27EQ`,
      },
    ],
    who_should_buy: [
      {
        label: `Any business who deals in the goods on which TCS is required to be collected`,
      },
    ],
    doc_required: [
      {
        label: `Deducted details to be filled in the template for Form 27EQ. Teamplate can be downloaded from 'Resource' page`,
      },
      {
        label: `Deducted Details`,
      },
      {
        label: `Challan details`,
      },
      {
        label: `Copy of Acknowledgement for last Quarter return`,
      },
    ],
  },
  {
    _id: `5`,
    type: `GST RETURN`,
    label: `GST RETURN - QUARTERLY`,
    price: `2999`,
    about: `Covers all GST compliance for 3 months - Filing of GSTR 1 & GSTR 3B return`,
    service: [
      {
        label: `GST Return Filing [both GSTR 1 & 3B] for 3 months for One GSTIN`,
      },
      {
        label: `Review of Purchase & ITC Register`,
      },
      {
        label: `Review of GSTR 2B and reconciliation with ITC Register`,
      },
      {
        label: `Both Sales & purchase monthly returns covered`,
      },
    ],
    who_should_buy: [
      {
        label: `Traders & Small Businesses`,
      },
      {
        label: `Freelancers`,
      },
      {
        label: `E commerce sellers`,
      },
      {
        label: `Service Providers`,
      },
      {
        label: `Any business required to get registered under GST`,
      },
    ],
    doc_required: [
      {
        label: `Purchase or ITC register`,
      },
      {
        label: `Sales Register`,
      },
      {
        label: `Tax payment challans`,
      },
      {
        label: `GSTR 2B data from GST portal`,
      },
    ],
  },
  {
    _id: `5`,
    type: `GST RETURN`,
    label: `GST RETURN - ANNUAL`,
    price: `11999`,
    about: `Covers all GST compliance for one year - Filing of GSTR 1 & GSTR 3B return and one GST Registration`,
    service: [
      {
        label: `GST Return Filing [both GSTR 1 & 3B] for 12 months for One GSTIN`,
      },
      {
        label: `Registration of one new GSTIN`,
      },
      {
        label: `Review of GSTR 2B and reconciliation with ITC Register`,
      },
      {
        label: `Review of Purchase & ITC Register`,
      },
      {
        label: `Filing of GSTR 9 - Annual return`,
      },
    ],
    who_should_buy: [
      {
        label: `Traders & Small Businesses`,
      },
      {
        label: `Freelancers`,
      },
      {
        label: `E commerce sellers`,
      },
      {
        label: `Service Providers`,
      },
      {
        label: `Any business required to get registered under GST`,
      },
    ],
    doc_required: [
      {
        label: `Purchase or ITC register`,
      },
      {
        label: `Sales Register`,
      },
      {
        label: `Tax payment challans`,
      },
      {
        label: `GSTR 2B data from GST portal`,
      },
    ],
  },
  {
    _id: `5`,
    type: `GST RETURN`,
    label: `GST RETURN - ANNUAL`,
    price: `11999`,
    about: `Covers all GST compliance for one year - Filing of GSTR 1 & GSTR 3B return and one GST Registration`,
    service: [
      {
        label: `GST Return Filing [both GSTR 1 & 3B] for 12 months for One GSTIN`,
      },
      {
        label: `Registration of one new GSTIN`,
      },
      {
        label: `Review of GSTR 2B and reconciliation with ITC Register`,
      },
      {
        label: `Review of Purchase & ITC Register`,
      },
      {
        label: `Filing of GSTR 9 - Annual return`,
      },
    ],
    who_should_buy: [
      {
        label: `Traders & Small Businesses`,
      },
      {
        label: `Freelancers`,
      },
      {
        label: `E commerce sellers`,
      },
      {
        label: `Service Providers`,
      },
      {
        label: `Any business required to get registered under GST`,
      },
    ],
    doc_required: [
      {
        label: `Purchase or ITC register`,
      },
      {
        label: `Sales Register`,
      },
      {
        label: `Tax payment challans`,
      },
      {
        label: `GSTR 2B data from GST portal`,
      },
    ],
  },
  {
    _id: `6`,
    type: `GST RETURN`,
    label: `GST RETURN - 1 & 3B`,
    price: `1199`,
    about: `Filing of GSTR 1 & GSTR 3B for one month / one quarter for QRMP scheme`,
    service: [
      {
        label: `GST Return Filing [both GSTR 1 & 3B] for 1 month for One GSTIN`,
      },
      {
        label: `Review of Purchase & ITC Register`,
      },
      {
        label: `Review of GSTR 2B and reconciliation with ITC Register`,
      },
      {
        label: `Both Sales & purchase monthly returns covered`,
      },
    ],
    who_should_buy: [
      {
        label: `Purchase or ITC register`,
      },
      {
        label: `Sales Register`,
      },
      {
        label: `Tax payment challans`,
      },
      {
        label: `GSTR 2B data from GST portal`,
      },
    ],
    doc_required: [
      {
        label: `Traders & Small Businesses`,
      },
      {
        label: `Freelancers`,
      },
      {
        label: `E commerce sellers`,
      },
      {
        label: `Service Providers`,
      },
      {
        label: `Any business required to get registered under GST`,
      },
    ],
  },
  {
    _id: `7`,
    type: `GST RETURN`,
    label: `GSTR 9 - ANNUAL RETURN`,
    price: `1499`,
    about: `Filing of Annual return Form GSTR 9`,
    service: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    who_should_buy: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    doc_required: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
  },
  {
    _id: `8`,
    type: `GST RETURN`,
    label: `GST RETURNS - E COMMERCE`,
    price: `899`,
    about: `This plan is specially designed for suppliers or service providers on all E-commerce platform. This plan includes GST Registration and Return filing for one month - GSTR 1 & GSTR 3B`,
    service: [
      {
        label: `One new GST Registration`,
      },
      {
        label: `GST Return Filing [both GSTR 1 & 3B] for 3 months for One GSTIN`,
      },
      {
        label: `Review of Purchase & ITC Register`,
      },
      {
        label: `Review of GSTR 2B and reconciliation with ITC Register`,
      },
      {
        label: `Both Sales & purchase monthly returns covered`,
      },
    ],
    who_should_buy: [
      {
        label: `Sellers on Amazon`,
      },
      {
        label: `Sellers on Flipkart`,
      },
      {
        label: `Sellers or service providers on any other E-commerce platform`,
      },
    ],
    doc_required: [
      {
        label: `Purchase or ITC register`,
      },
      {
        label: `Sales Register`,
      },
      {
        label: `Tax payment challans`,
      },
      {
        label: `GSTR 2B data from GST portal`,
      },
    ],
  },
  {
    _id: `9`,
    type: `TRADEMARK`,
    label: `TRADEMARK - INDIVIDUAL`,
    price: `5499`,
    about: `Registration of Brand, logo or Trademark under Office of Controller General of Patents, Designs and Trade Marks`,
    service: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    who_should_buy: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    doc_required: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
  },
  {
    _id: `10`,
    type: `TRADEMARK`,
    label: `TRADEMARK - COMPANY`,
    price: `9999`,
    about: `Registration of Brand, logo or Trademark under Office of Controller General of Patents, Designs and Trade Marks`,
    service: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    who_should_buy: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    doc_required: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
  },
  {
    _id: `11`,
    type: `TRADEMARK`,
    label: `GST REGISTRATION`,
    price: `999`,
    about: `This plan is designed to help your business to comply with GST regulations and cater to all compliance and registration requirements along with expert advisory.`,
    service: [
      {
        label: `Filing of application for GST registration`,
      },
      {
        label: `Follow up and providing clarification, if any, sought by GST department`,
      },
    ],
    who_should_buy: [
      {
        label: `Any business having turnover of more than Rs 20 lakhs in a financial year`,
      },
      {
        label: `Traders selling goods online through e-commerce platforms`,
      },
      {
        label: `Already registered business under Central Excise, VAT or Service Tax`,
      },
    ],
    doc_required: [
      {
        label: `PAN of the business`,
      },
      {
        label: `Aadhar of the applicant`,
      },
      {
        label: `Business registration proof / certificate`,
      },
      {
        label: `Address proof, bank statement or cancelled cheque`,
      },
    ],
  },
  {
    _id: `12`,
    type: `TRADEMARK`,
    label: `MSME REGISTRATION`,
    price: `899`,
    about: `Application of food License under FSSAI`,
    service: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    who_should_buy: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
    doc_required: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
    ],
  },
  {
    _id: `13`,
    type: `TRADEMARK`,
    label: `PF REGISTRATION`,
    price: `1499`,
    about: `Registration PF license`,
    service: [
      {
        label: `Application of PF registration`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
    ],
    who_should_buy: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
    ],
    doc_required: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
    ],
  },
  {
    _id: `13`,
    type: `TRADEMARK`,
    label: `IMPORT EXPORT CODE LICENSE`,
    price: `1499`,
    about: `Import Export Code (also known as IEC code) is issued by the DGFT (Director General of Foreign Trade), Department of Commerce. Companies and businesses must obtain this code to start a business that deals with import and export in the Indian Territory.`,
    service: [
      {
        label: `Preparation of application form`,
      },
      {
        label: `Obtaining Import Export Code`,
      },
      {
        label: `Advisory on requirement of the registration`,
      },
      {
        label: `Support and follow-up documentation`,
      },
    ],
    who_should_buy: [
      {
        label: `Every exporter or importer of goods`,
      },
      {
        label: `Service provider serving to customers outside India`,
      },
    ],
    doc_required: [
      {
        label: `PAN of the IEC applicant & Business Entity`,
      },
      {
        label: `Bank certificate and cancelled cheque of the business entity`,
      },
      {
        label: `Digital Signature and photo of the applicant`,
      },
      {
        label: `Address proof of directors`,
      },
    ],
  },
  {
    _id: `14`,
    type: `DIGITAL SIGNATURE`,
    label: `DIGITAL SIGNATURE CLASS 3`,
    price: `1499`,
    about: `Class 3 digital signature with token - validity 2 years`,
    service: [
      {
        label: `Digital Signature Certificate`,
      },
      {
        label: `DSC USB e-token included`,
      },
      {
        label: `Delivered to your office / home address`,
      },
      {
        label: `2 years validity`,
      },
    ],
    who_should_buy: [
      {
        label: `Company filings with MCA`,
      },
      {
        label: `Individual, HUF or other entities who are required to get tax audit under the Income Tax Act`,
      },
      {
        label: `Individual / Business who need to apply for a Trademark`,
      },
      {
        label: `Required for GST and other regulatory filings`,
      },
    ],
    doc_required: [
      {
        label: `PAN Card`,
      },
      {
        label: `Aadhar Card`,
      },
      {
        label: `Address proof`,
      },
      {
        label: `Passport size photo`,
      },
    ],
  },
  {
    _id: `15`,
    type: `DIGITAL SIGNATURE`,
    label: `DIGITAL SIGNATURE - DGFT`,
    price: `1599`,
    about: `Class 3 digital signature with token - validity 2 years`,
    service: [
      {
        label: `Application for DSC for DGFT`,
      },
      {
        label: `USB E-Token couriered to your address`,
      },
      {
        label: `2 years validity`,
      },
    ],
    who_should_buy: [
      {
        label: `Filings with DGFT for a particular organisation`,
      },
      {
        label: `Business who are required to get tax audit under the Income Tax Act`,
      },
      {
        label: `Individual / Business who need to apply for a Trademark`,
      },
      {
        label: `Required for GST and other regulatory filings`,
      },
    ],
    doc_required: [
      {
        label: `PAN & Aadhar Card`,
      },
      {
        label: `Address proof`,
      },
      {
        label: `Passport size photo`,
      },
      {
        label: `Board Resolution in case of Company / LLP`,
      },
    ],
  },
  {
    _id: `16`,
    type: `DIGITAL SIGNATURE`,
    label: `DSC CLASS 3 - ORGANISATION`,
    price: `1599`,
    about: `Class 3 digital signature with token - validity 2 years`,
    service: [
      {
        label: `Digital Signature Certificate`,
      },
      {
        label: `DSC USB e-token included`,
      },
      {
        label: `2 years validity`,
      },
    ],
    who_should_buy: [
      {
        label: `Company filings with MCA`,
      },
      {
        label: `Business who are required to get tax audit under the Income Tax Act`,
      },
      {
        label: `Individual / Business who need to apply for a Trademark`,
      },
      {
        label: `Required for GST and other regulatory filings`,
      },
    ],
    doc_required: [
      {
        label: `PAN & Aadhar Card`,
      },
      {
        label: `Address proof`,
      },
      {
        label: `Passport size photo`,
      },
      {
        label: `Board Resolution in case of Company / LLP`,
      },
    ],
  },

  {
    _id: `17`,
    type: `DIGITAL SIGNATURE`,
    label: `DSC CLASS 3 COMBO`,
    price: `1599`,
    about: `Digital signature + encryption combo valid for 2 years`,
    service: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
    ],
    who_should_buy: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
    ],
    doc_required: [
      {
        label: `Business`,
      },
      {
        label: `Trader`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
      {
        label: `Lorem ipsum dolor sit amet`,
      },
    ],
  },
  {
    _id: `18`,
    type: `PRIVATE LIMITED`,
    label: `PRIVATE LIMITED COMPANY`,
    price: `7499`,
    about: `Incorporation of Private limited company as per regulatory requirements of Ministry of Corporate Affairs`,
    service: [
      {
        label: `Filing of SPICe form`,
      },
      {
        label: `Name Approval in RUN`,
      },
      {
        label: `Digital Signature [upto 2 directors]`,
      },
      {
        label: `Government fees and stamp duty included`,
      },
    ],
    who_should_buy: [
      {
        label: `Business who want to scale up and enjoy limited liability benefit`,
      },
      {
        label: `Partnership firm who want to convert to corporate structured business`,
      },
      {
        label: `Startups looking to raise capital`,
      },
    ],
    doc_required: [
      {
        label: `Photo ID proof of partners`,
      },
      {
        label: `Address proof of partners`,
      },
      {
        label: `No objection certificate from the owner of the property of the property`,
      },
      {
        label: `Aadhar card and PAN of the directors`,
      },
    ],
  },
  {
    _id: `19`,
    type: `PRIVATE LIMITED`,
    label: `LIMITED LIABILITY PARTNERSHIP`,
    price: `4999`,
    about: `Incorporation of Private limited company as per regulatory requirements of Ministry of Corporate Affairs`,
    service: [
      {
        label: `Filing of SPICe form`,
      },
      {
        label: `Name Approval in RUN`,
      },
      {
        label: `Digital Signature [upto 2 directors]`,
      },
      {
        label: `Government fees and stamp duty included`,
      },
    ],
    who_should_buy: [
      {
        label: `Business who want to scale up and enjoy limited liability benefit`,
      },
      {
        label: `Partnership firm who want to convert to corporate structured business`,
      },
      {
        label: `Startups looking to raise capital`,
      },
    ],
    doc_required: [
      {
        label: `Photo ID proof of partners`,
      },
      {
        label: `Address proof of partners`,
      },
      {
        label: `No objection certificate from the owner of the property of the property`,
      },
      {
        label: `Aadhar card and PAN of the directors`,
      },
    ],
  },
  {
    _id: `20`,
    type: `PRIVATE LIMITED`,
    label: `PARTNERSHIP REGISTRATION`,
    price: `2499`,
    about: `Partnership registration via creation of partnership deed, PAN & GST registration`,
    service: [
      {
        label: `Filing of SPICe form`,
      },
      {
        label: `Name Approval in RUN`,
      },
      {
        label: `Digital Signature [upto 2 directors]`,
      },
      {
        label: `Government fees and stamp duty included`,
      },
    ],
    who_should_buy: [
      {
        label: `Business who want to scale up and enjoy limited liability benefit`,
      },
      {
        label: `Partnership firm who want to convert to corporate structured business`,
      },
      {
        label: `Startups looking to raise capital`,
      },
    ],
    doc_required: [
      {
        label: `Photo ID proof of partners`,
      },
      {
        label: `Address proof of partners`,
      },
      {
        label: `No objection certificate from the owner of the property of the property`,
      },
      {
        label: `Aadhar card and PAN of the directors`,
      },
    ],
  },
  {
    _id: `21`,
    type: `PRIVATE LIMITED`,
    label: `ONE PERSON COMPANY (OPC)`,
    price: `2499`,
    about: `Incorporation of one person company`,
    service: [
      {
        label: `Name approval`,
      },
      {
        label: `Filing of E-forms`,
      },
      {
        label: `One Digital Signature - Class 3`,
      },
      {
        label: `Includes Govt fees & Stamp duty`,
      },
    ],
    who_should_buy: [
      {
        label: `Proprietorship who wants to enjoy benefit of limited liability`,
      },
      {
        label: `Startup with sole founder who want to operate in corporate structure`,
      },
    ],
    doc_required: [
      {
        label: `Photo ID proof of partners`,
      },
      {
        label: `Address proof of partners`,
      },
      {
        label: `No objection certificate from the owner of the property of the property`,
      },
      {
        label: `Aadhar card and PAN of the directors`,
      },
    ],
  },
];
